<template>
  <v-list-group
    v-model="isOpen"
    no-action
    append-icon=""
    class="drawer-group"
    :class="{
      'drawer-group--current': matchesCurrentRoute,
      'drawer-group--nested': subGroup,
    }"
  >
    <template slot="activator">
      <button
        type="button"
        class="drawer-group-trigger"
        :aria-expanded="String(isOpen)"
        :aria-controls="panelId"
      >
        <v-icon v-if="item.icon" aria-hidden="true">{{ item.icon }}</v-icon>
        <span>{{ item.text }}</span>
        <v-icon class="drawer-group-chevron" aria-hidden="true"
          >expand_more</v-icon
        >
      </button>
    </template>
    <div :id="panelId">
      <template v-for="(child, i) in children">
        <list-group
          v-if="child.group"
          :key="`sub-group-${i}`"
          :item="child"
          sub-group
        />
        <list-item
          v-else
          :key="`item-${i}`"
          :icon="child.icon"
          :subtext="child.subtext"
          :to="child.to"
          :text="child.text"
        />
      </template>
    </div>
  </v-list-group>
</template>
<script>
import ListItem from './Item'
import { isMenuGroupActive } from '@/helpers/Navigation'

export default {
  name: 'ListGroup',
  components: { ListItem },
  props: {
    item: {
      type: Object,
      default: () => ({ text: '', group: '', children: [] }),
    },
    subGroup: { type: Boolean, default: false },
  },
  data: () => ({ isOpen: false }),
  computed: {
    children() {
      return this.item.children || []
    },
    panelId() {
      return 'navigation-group-' + this._uid
    },
    matchesCurrentRoute() {
      return isMenuGroupActive(this.item, this.$route)
    },
  },
  watch: {
    matchesCurrentRoute: {
      immediate: true,
      handler(matches) {
        if (matches) this.isOpen = true
      },
    },
    '$route.fullPath'() {
      if (this.matchesCurrentRoute) this.isOpen = true
    },
  },
}
</script>
